export default {
    tree: {
        save: '/basic/brch/save', // 添加组织
        update: '/basic/brch/batch', // 批量激活、冻结、删除组织节点
        info: '/basic/brch/query/', // 编辑时查询单个组织节点数据
        modify: '/basic/brch/update', // 修改
        tree: '/basic/brch/queryTreeBrch', // 异步查询组织树
        permissionsTree: '/basic/permissions/queryTree', // 人员权限树
        changepermissionsTree: '/basic/permissions/auth', // 修改人员权限树
        queryTreeByType: '/basic/statements/queryTreeByType', // 指标报表（报表查询，指标查询公用这颗树）
        queryPermission: '/basic/permissions/queryPermission' // 获取角色历史菜单（默认选择用）
    },
    save: '/basic/users/save', // 新增用户
    delete: '/basic/users/del', // 新增用户
    update: '/basic/users/update', // 修改人员
    list: '/basic/users/queryUserPageList', // 用户列表查询
    batch: 'basic/users/batch', // 批量操作
    export: '/basic/users/downloadUserListInfo', // 导出
    userAuthorization: '/basic/users/userAuthorization' // 用户角色授权
};
